'use client';

import { StatisticsQueryParams } from '@/lib/types';
import { capitalize } from '@/lib/utils';
import { Button, Flex } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';

import classnames from './statistics.module.css';

type Props = {
  params: StatisticsQueryParams;
  setParams: (params: any) => void;
};

const TODAY = new Date();
const MIN_DATE = new Date('2016-09-01');

const btns = [
  {
    id: 1,
    title: 'barchasi',
    variant: 'default',
    state: 'all',
    value: undefined,
  },
  {
    id: 2,
    title: 'jismoniy-shaxs',
    variant: 'default',
    state: 'phisical',
    value: '1',
  },
  {
    id: 3,
    title: 'yuridik-shaxs',
    variant: 'default',
    state: 'juridical',
    value: '2',
  },
];

export function StatisticsForm({ params, setParams }: Props) {
  const t = useTranslations();

  return (
    <Flex gap="lg" align="flex-end" wrap="wrap">
      <Button.Group className="flex w-full flex-wrap">
        {btns.map((btn) => (
          <Button
            key={btn.id}
            variant={btn.value === params.applicant_type ? 'filled' : btn.variant}
            onClick={() => setParams((prevState: any) => ({ ...prevState, applicant_type: btn.value }))}
            size="md"
            radius="0"
            aria-label={t('Qidiruv')}
            className={classnames.group_btns}
            classNames={{ root: classnames.submit__btn }}
          >
            {t(btn.title)}
          </Button>
        ))}
      </Button.Group>
      <DateInput
        onChange={(value) =>
          setParams((prevState: any) => {
            if (value === null) {
              return { ...prevState, start_date: undefined };
            } else {
              return { ...prevState, start_date: dayjs(value).format('YYYY-MM-DD') };
            }
          })
        }
        classNames={{ ...classnames, root: classnames.root__datepicker }}
        clearable
        valueFormat="YYYY-MM-DD"
        minDate={MIN_DATE}
        label={capitalize(t('bo‘lgan davr dan'))}
        placeholder={capitalize(t('bo‘lgan davr dan'))}
      />
      <DateInput
        onChange={(value) =>
          setParams((prevState: any) => {
            if (value === null) {
              return { ...prevState, end_date: undefined };
            } else {
              return { ...prevState, end_date: dayjs(value).format('YYYY-MM-DD') };
            }
          })
        }
        classNames={{ ...classnames, root: classnames.root__datepicker }}
        clearable
        valueFormat="YYYY-MM-DD"
        maxDate={TODAY}
        label={capitalize(t('davr gacha'))}
        placeholder={capitalize(t('davr gacha'))}
      />
    </Flex>
  );
}
